import { connect } from 'react-redux';
import Notifications from './Notifications';

const mapStateToProps = ({ messages }) => ({ ...messages });

export default connect(
  mapStateToProps
)(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/connectToStore.js